import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplymentModel } from '@app/services/client-general-settings/applyment/applyment.model';
import { LoginService } from '@app/services/portal/login/login.service';
import { DialogPopupFormComponent } from '@shared/components/dialog/template/dialog-popup-form/dialog-popup-form.component';
import { PopUp } from '@app/services/pop-up/pop-up';
import { ConfirmService } from '@shared/components/confirm/confirm.service';
import { LoaderService } from '@shared/components/loader/loader.service';
import { DialogLoginComponent } from '../dialog/dialog-login.component';
import { RecaptchaComponent } from '@shared/components/captcha/recaptcha/recaptcha.component';
import { isValidCPF } from '@shared/utils/util';
@Component({
  selector: 'app-form-login',
  templateUrl: './form-login.component.html',
  styleUrls: ['./form-login.component.scss']
})
export class FormLoginComponent implements OnInit {

  @Input() isDialog = false;
  @Input() loginData = {
    login: '',
    birthDate: '',
    token_captcha: ''
  };
  @Input() hasAutoLogin = false;
  public hide = true;
  public formulario: FormGroup;
  public isCpfMask = true;
  public domainParam = '';
  public recaptcha: any;
  public errorCaptcha: Boolean = false;
  public messageErrorCaptcha: any;
  public invalidCaptcha: Boolean = false;
  public tempExpirationToken: any;
  public fields: any;
  public paddingFields: string;

  @ViewChild(RecaptchaComponent)
  recaptchaComponent: RecaptchaComponent;

  constructor(
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private loaderService: LoaderService,
    public dialogRef: MatDialogRef<FormLoginComponent>,
    private route: Router,
    public activatedRoute: ActivatedRoute,
    private applymentModel: ApplymentModel,
    private confirmService: ConfirmService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    // se for dentro de um dialog
    if (this.dialogRef.componentInstance) {
      this.isDialog = true;
    }
    this.loadFields();
    this.setCaptcha();
    this.paddingFields = this.definePadding();

    this.domainParam = this.applymentModel.getSettings().domainParams;
    this.formulario.valueChanges.subscribe(val => {
      this.isInvalidCaptcha();
    });

    if (this.hasAutoLogin) {
      setTimeout(() => {
        this.onSubmit();
      }, 500);
    }
  }

  loadFields() {
    this.fields = this.applymentModel.getSettings().fields_login;
    this.createForm();
  }

  public definePadding() {
    if (this.isDialog) {
      return this.recaptcha && this.recaptcha.active ? '20px 36px 0px 36px' : '36px 36px 0px 36px'
    } else {
      return '0px';
    }
  }

  createForm() {
    const formGroupConfig = {};
    formGroupConfig['token_captcha'] = [''];
    this.fields.forEach(field => {
      const validator = [Validators.required];
      if (field.type == 'cpf') {
        validator.push(this.validCPF);
      }
      const value = this.hasAutoLogin ? this.getAutoLoginValue(field.formControlName) : '';
      formGroupConfig[field.formControlName] = [value, validator];
    });

    this.formulario = this.formBuilder.group(formGroupConfig);
  }

  executeRecaptchaInvisible() {
    this.recaptchaComponent.executeRecaptchaInvisible('rubeus_login_portal').then(() => {
      this.actionSubmit();
    });
  }

  onSubmit() {
    if (this.recaptcha && this.recaptcha.active) {
      if (this.recaptcha.type === 'invisible') {
        this.executeRecaptchaInvisible();
      }

      if (this.recaptcha.type === 'normal') {
        this.actionSubmit();
        this.resetRecaptcha();
      }
    } else {
      this.actionSubmit();
    }
  }

  validCPF(input) {
    if (!input.value) {
      return null;
    }
    return isValidCPF(input.value) ? null : { invalidCPF: true };
  }

  actionSubmit() {
    this.formulario.updateValueAndValidity();
    if (this.formulario.invalid) {
      return this.formulario.markAllAsTouched();
    }
    if (this.tempExpirationToken) {
      clearTimeout(this.tempExpirationToken);
      window['grecaptcha'].reset();
    }

    const token = localStorage.getItem('token');
    const data = {
      domain: this.applymentModel.getSettings().domain,
      user_data: this.formulario.value,
      error_captcha: {
        error: this.errorCaptcha,
        messageErrorCaptcha: this.messageErrorCaptcha
      },
      token,
      substitute_id: localStorage.getItem('substitute_id_tracking_' + token),
      session_id: localStorage.getItem('session_id_tracking_' + token),
      hostClient: localStorage.getItem('hostClient_tracking_' + token),
    };
    this.loaderService.setChangesLoaderState(true);
    this.loginService.create(data).subscribe(
      success => {
        localStorage.setItem('process_id', null);
        if (success.success && success.data.lgpd_popup) {
          this.applymentModel.getSettings().selective_process_id = success.data.selective_process_id;
          this.openPopupLgpd(success.data.lgpd_popup, success.data.lgpdDataFromPopUp);
        }
        if (success.data && typeof success.data === 'object') {
          localStorage.setItem('session_id', success.data.session_id);
          if (success.data.person_id && success.data.applyment_id) {
            this.route.navigate([this.applymentModel.getSettings().domainParams, 'portal-inscrito'], { queryParamsHandling: this.hasAutoLogin ? '' : 'preserve' });
          } else if (success.data.person_id) {
            this.loaderService.setChangesLoaderState(
              false,
              'Encontramos seus dados, mas não encontramos uma inscrição sua. Por favor, inicie uma nova inscrição',
              'ok',
              'success'
            );
            this.route.navigate([this.applymentModel.getSettings().domainParams]);
          }
          if (this.isDialog) {
            this.dialogRef.close();
          }
        } else {
          if (this.isDialog || !success.data.includes('usuário')) {
            this.loaderService.setChangesLoaderState(false,
              success.data,
              'ok',
              'default',
              'Não foi possivel fazer o login',
              5000
            );
          } else {
            this.openDialogConfirm(success.data);
          }
        }
      },
      error => {
        this.loaderService.setChangesLoaderState(false,
          error.body,
          '',
          'error',
          error.title,
          5000);
      }
    );
  }

  setCaptcha() {
    this.recaptcha = this.applymentModel.getSettings().captcha ?? null;
  }

  resetRecaptcha() {
    this.recaptchaComponent.reset();
    this.formulario.patchValue({
      token_captcha: ''
    });
  }

  expiredToken() {
    this.formulario.patchValue({
      token_captcha: null,
    })
  }

  sendedToken(token: any) {
    this.formulario.patchValue({
      token_captcha: token
    })
  }

  isInvalidCaptcha(): void {

    if (!this.recaptcha) {
      this.invalidCaptcha = false;
      return;
    }

    if (this.errorCaptcha) {
      this.invalidCaptcha = false;
      return;
    }
    if (this.recaptcha.active) {
      if (this.recaptcha.type == 'invisible' || this.recaptcha.type == 'v3') {
        this.invalidCaptcha = false;
        return;
      }
      if (!this.formulario.controls.token_captcha.value) {
        this.invalidCaptcha = true;
      } else {
        this.invalidCaptcha = false;
      }
    } else {
      this.invalidCaptcha = false;
    }
  }

  captureErrorCaptcha(error) {
    this.messageErrorCaptcha = error;
    this.errorCaptcha = true;
  }

  openDialogConfirm(msg): void {
    this.confirmService
      .openConfirm(
        'Não foi possivel fazer o login',
        msg,
        'Iniciar inscrição',
        'Cancelar',
        true
      )
      .afterClosed()
      .subscribe(confirm => {
        if (confirm) {
          this.route.navigate([this.applymentModel.getSettings().domainParams], { queryParamsHandling: 'preserve' });
        }
      }
      );
  }

  public openPopupLgpd(popupLgpd: PopUp, lgpdDataFromPopUp): void {
    this.dialog.open(DialogLoginComponent, {
      maxWidth: popupLgpd.maximum_width ? popupLgpd.maximum_width + 'px' : '600' + 'px',
      width: 'inherit',
      disableClose: true,
      data: {
        component: DialogPopupFormComponent,
        contentDialogClassName: 'ps-dialog-form-popup-content',
        closeButton: false,
        lgpdDataFromPopUp,
        data: popupLgpd
      },
      autoFocus: false
    });
  }

  private getAutoLoginValue(field: string) {
    switch (field) {
      case 'typeLogin':
        return this.loginData.login;
      case 'dataNascimento':
        return this.loginData.birthDate;
      default:
        return '';
    }
  }

  get f() {
    return this.formulario.controls;
  }
}
